<template>
    <div class="OOP-today OOP-today__oop" v-if="groupedMatches.length > 0">
        <div class="player-filter__type player-filter__type--full">
            <select ref="courtSelector" id="courtSelector" name="courtSelector" v-model="selectedCourt">
                <option v-for="(court, courtIndex) in courts" :value="court.id">{{ getCourtName( court.id, court.name ) }}</option>
            </select>
        </div>

        <div class="OOP-today__caption">
            {{ getCourtName( selectedCourt ) }} Order of Play
        </div>

        <flickity ref="flickity" :options="flickityOptions" class="OOP-today__flickity" v-if="Object.keys(groupedMatches).length > 0">

            <div class="OOP-today__matches__row" v-for="rowMatches in groupedMatches">
                <oop-match v-for="match in rowMatches"
                           :key="match.id"
                           :wta="wtaMatches"
                           :flagPath="flagPath"
                           :type="assoc"
                           :match="match"
                           :detail="detail"
                           :events   = "events">
                </oop-match>
            </div>

        </flickity>

        <div class="go-more">
            <a :href="oop_url">Full Order of Play</a>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import OOPMatch from './OOPMatchSC'
    import Flickity from './Flickity';
    import 'select2/dist/js/select2.full.js'
    import tz from 'moment-timezone'

    export default {
        props: [ 'assoc', 'tournament', 'flag', 'detail', 'oop_url' ],
        components: {
            'oop-match': OOPMatch,
            Flickity
        },
        data() {
            return {
                flagPath        : this.flag + '/assets/dist/svg/flags/',
                oop             : [],
                today           : '',
                wtaFeed         : [],
                wtaMatches      : [],
                selectedCourt   : '',
                matches         : [],
                courts          : [],
                tournament_slug : this.tournament,
                type            : this.assoc,
                flickityOptions : {
                    cellSelector    : '.OOP-today__matches__row',
                    prevNextButtons : true,
                    pageDots        : true,
                },
                events      : [],
                windowWidth : window.innerWidth,
                websiteCourts : window.court_stadium,
            }
        },
        mounted() {
            let app = this

            setTimeout( function() {
                jQuery('#courtSelector').select2({
                    width: '100%'
                }).on('change', function () {
                    app.selectedCourt = this.value
                })
            }, 1500 )

            window.addEventListener('resize', this.handleResize)
        },
        watch: {
            selectedCourt(newValue, oldValue) {
                let carousel = jQuery('.OOP-today__oop .OOP-today__flickity').flickity()
                carousel.flickity('destroy')

                let matches = this.getMatchesByCourt(newValue)
                let assoc = this.type

                this.matches = matches.filter( function( match ) {
                    if ( match.type == assoc )
                        return true
                })

                let app = this

                setTimeout( function() {
                    let holder_height = jQuery('.OOP-today__oop .OOP-match__head').outerHeight() + jQuery('.OOP-today__oop .OOP-match').outerHeight()

                    let max_outer_height         = 0
                    let max_match_height         = 0
                    let max_player_holder_height = 0

                    //height
                    jQuery('.OOP-today__oop .OOP-today__flickity').css( { 'height' : holder_height + 35 } )
                    jQuery('.OOP-today__oop .OOP-today__matches__row').css( { 'height' : holder_height + 35 } )

                    jQuery('.OOP-today__oop .OOP-match__holder').each( function () {
                        let outer_height         = jQuery( '.OOP-match__head', this ).outerHeight() + jQuery( '.OOP-match', this ).outerHeight() + 4
                        let match_height         = jQuery( '.OOP-match', this ).outerHeight()
                        let player_holder_height = jQuery( '.OOP-match .OOP-match__player__holder', this ).outerHeight()

                        if( outer_height > max_outer_height )
                            max_outer_height = outer_height

                        if( match_height > max_match_height )
                            max_match_height = match_height

                        if( player_holder_height > max_player_holder_height )
                            max_player_holder_height = player_holder_height

                    })

                    jQuery('.OOP-today__oop .OOP-match__holder').each( function () {

                        jQuery(this).css( { 'max-height' : max_outer_height } )
                        jQuery( '.OOP-match', this ).css( { 'height' : max_match_height } )
                        jQuery( '.OOP-match .OOP-match__player__holder', this ).css( { 'height' : max_player_holder_height } )

                    })

                    jQuery('.OOP-today__oop .OOP-today__flickity').flickity( [ this.flickityOptions ] )

                    if ( app.groupedMatchesWatch().length < 2 )
                        jQuery( '.OOP-today__oop .flickity-page-dots' ).hide()
                    else
                        jQuery( '.OOP-today__oop .flickity-page-dots' ).show()
                }, 50 )
            }
        },
        created() {
            this.getFeed().then( () => {
                this.initCarousel()
            })

            this.setupRounds()
        },
        computed: {
            groupedMatches() {
                let grouped = []
                let index = -1
                let modulo

                const windowWidth = this.windowWidth

                //1 per page =< 768, 2 per page > 768
                if ( window.matchMedia("(min-width: 769px)").matches )
                    modulo = 2
                else
                    modulo = 1

                for ( let i = 0; i < this.matches.length; i++ ) {
                    if (i % modulo == 0) {
                        index++
                        grouped[index] = []
                    }
                    grouped[index].push(this.matches[i])
                }

                return grouped
            }
        },
        methods: {
            getFeed() {

                return axios.get(`${window.feed_ip}/get/${this.type}/${this.tournament_slug}/oop`).then(response => {

                    let oop = response.data

                    var todayDate = moment().tz('Asia/Dubai').startOf('day').format('YYYY-MM-DD')

                    let today = oop.filter(function (day) {
                        return day.date == todayDate
                    })

                    if( response.data.length == 1 && today.length == 0 )
                        today = oop

                    this.oop = response.data

                    if (today.length == '0') {

                        let totalDaysCount = response.data.length
                        this.today = response.data[totalDaysCount - 1]

                        for ( let i = 0; i < response.data[totalDaysCount - 1].courts.length; i++ ) {
                            if ( response.data[totalDaysCount - 1].courts[i].matches.length >= 1 ) {
                                this.selectedCourt = response.data[totalDaysCount - 1].courts[i].id
                                break;
                            }
                        }

                    } else {

                        this.today = today[0]

                        for ( let i = 0; i < today[0].courts.length; i++ ) {
                            if ( today[0].courts[i].matches.length >= 1 ) {
                                this.selectedCourt = today[0].courts[i].id
                                break;
                            }
                        }

                    }

                    today = this.filterMatchesByType( today[0], this.type )

                    let matches = this.getMatchesByCourt(this.selectedCourt)
                    let assoc = this.type

                    this.matches = matches.filter( function( match ) {
                        if ( match.type == assoc )
                            return true
                    })

                    this.setupCourts()

                }).catch(function (error) {
                    console.log(error);
                });
            },
            filterMatchesByType(day, type) {
                if( !day )
                    return day

                day.courts.forEach( function ( court, j ) {
                    day.courts[j].matches = court.matches.filter( function( match ) {
                        if ( match.type == type )
                            return true
                    })
                })

                return day
            },
            setupCourts() {
                let courts = []
                let today = this.filterMatchesByType( this.today, this.type )

                today.courts.forEach( function( court, j ) {
                    if ( court.matches.length > 0 ){
                        courts.push( { 'name': court.name, 'id': court.id } )
                    }

                })

                if ( courts.length < 1 ) {
                    let totalDaysCount = this.oop.length

                    for ( let i = 0; i < this.oop[totalDaysCount - 1].courts.length; i++ ) {
                        if ( this.oop[totalDaysCount - 1].courts[i].matches.length >= 1 ) {
                            courts.push( this.oop[totalDaysCount - 1].courts[i].name )
                            break;
                        }
                    }
                }

                this.courts = courts

            },
            getMatchesByCourt(id) {
                let foundCourt = this.today.courts.filter(function (court) {
                    if ( court.id == id )
                        return true
                })

                return foundCourt[0].matches
            },
            groupedMatchesWatch() {
                let grouped = [];
                let index = -1;

                for (let i = 0; i < this.matches.length; i++) {
                    if (i % 2 == 0) {
                        index++;
                        grouped[index] = [];
                    }
                    grouped[index].push(this.matches[i]);
                }

                return grouped;
            },
            setupRounds() {
                axios.get(`${window.feed_ip}/${this.type}/update/rounds/${this.tournament_slug}`).then(response => {

                    this.events = response.data

                }).catch(function (error) {
                    console.log(error)
                })

            },
            handleResize() {

                if ( window.innerWidth > 760 && window.innerWidth < 920 ) {
                    this.windowWidth = window.innerWidth

                    this.initCarousel()
                }

            },
            initCarousel() {
                let carousel = jQuery('.OOP-today__oop .OOP-today__flickity').flickity()
                carousel.flickity('destroy')

                let holder_height = jQuery('.OOP-today__oop .OOP-match__head').outerHeight() + jQuery('.OOP-today__oop .OOP-match').outerHeight()

                let max_outer_height         = 0
                let max_match_height         = 0
                let max_player_holder_height = 0

                //height
                jQuery('.OOP-today__oop .OOP-today__flickity').css( { 'height' : holder_height + 35 } )
                jQuery('.OOP-today__oop .OOP-today__matches__row').css( { 'height' : holder_height + 35 } )

                jQuery('.OOP-today__oop .OOP-match__holder').each( function () {
                    let outer_height         = jQuery( '.OOP-match__head', this ).outerHeight() + jQuery( '.OOP-match', this ).outerHeight() + 4
                    let match_height         = jQuery( '.OOP-match', this ).outerHeight()
                    let player_holder_height = jQuery( '.OOP-match .OOP-match__player__holder', this ).outerHeight()

                    if( outer_height > max_outer_height )
                        max_outer_height = outer_height

                    if( match_height > max_match_height )
                        max_match_height = match_height

                    if( player_holder_height > max_player_holder_height )
                        max_player_holder_height = player_holder_height

                })

                jQuery('.OOP-today__oop .OOP-match__holder').each( function () {

                    jQuery(this).css( { 'max-height' : max_outer_height } )
                    jQuery( '.OOP-match', this ).css( { 'height' : max_match_height } )
                    jQuery( '.OOP-match .OOP-match__player__holder', this ).css( { 'height' : max_player_holder_height } )

                })

                jQuery('.OOP-today__oop .OOP-today__flickity').flickity( [ this.flickityOptions ] )
            },
            getCourtName( id, name ){
                if( this.websiteCourts && typeof this.websiteCourts[id] != 'undefined' )
                    return this.websiteCourts[id].stadium_name

                return name
            }
        }
    }
</script>
